import React from 'react'

export const useMainQueryKey = () =>
  React.useMemo(() => ['BrandAccountUserListPage_Main'], [])
